function validation() {
    const giftFormInputs = document.querySelectorAll(".gift_wrapper-form-input")
    let check = true
    giftFormInputs.forEach(input => {
        if (input.value == "") {
            input.classList.add("no_valid")
            check = false
        }
    })
    return check
}

function scrollToFormElement(from) {
    from.scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"})
}

function addCart(obj, data) {

    if(!validation()){
        return
    }
    const button_text = document.querySelector(".button_add_gift_wrapper-text")
    const load = document.querySelector(".gift_wrapper_load")
    button_text.classList.add("hidden")
    load.classList.remove("hidden")
    const giftFormInputs = document.querySelectorAll(".gift_wrapper-form-input")
    const objForm = {
        from: {
            name: giftFormInputs[0].getAttribute("placeholder"),
            value: giftFormInputs[0].value
        },
        to: {
            name: giftFormInputs[1].getAttribute("placeholder"),
            value: giftFormInputs[1].value
        },
        wishes: {
            name: giftFormInputs[2].getAttribute("placeholder"),
            value: giftFormInputs[2].value
        }

    }

    let formData = {
        'items': [{
            'id': data,
            'quantity': 1,
            'properties': {
                [objForm.from.name]: objForm.from.value,
                [objForm.to.name]: objForm.to.value,
                [objForm.wishes.name]: objForm.wishes.value
            }
        }]
    };
    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(response => {
            location.reload()
            document.body.scrollTop = document.documentElement.scrollTop = 0;


        })
        .catch((error) => {
            console.error('Error:', error);
        });


}

document.addEventListener("DOMContentLoaded", function () {
    const formGiftWrapper = document.querySelector(".gift_wrapper-form")
    const showFormCheckbox = document.querySelector(".main_checkbox")
    let colorSelector = document.querySelector(".ep_colors_selector-selected")

    showFormCheckbox?.addEventListener("change", (e) => {
        formGiftWrapper.classList.add("overflow")
        formGiftWrapper.style.maxHeight = !e.target.checked ? null : formGiftWrapper.scrollHeight + 'px';
        scrollToFormElement(formGiftWrapper)
        if(colorSelector){
            let content = colorSelector.nextElementSibling
            content.style.maxHeight = "0px";
            colorSelector.classList.remove("active")
        }

    })
    const giftFormInputs = document.querySelectorAll(".gift_wrapper-form-input")
    giftFormInputs.forEach(input => {
        input.addEventListener("input", (e) => {
            input.classList.remove("no_valid")
        })
    })



    if (colorSelector){
        colorSelector.addEventListener("click", (e) => {
            formGiftWrapper.classList.remove("overflow")
            e.stopPropagation();
            let content = colorSelector.nextElementSibling

            if (content.style.maxHeight != "0px" && content.style.maxHeight != "") {
                content.style.maxHeight = "0px";
                colorSelector.classList.remove("active")

                // content.style.padding = 0;

            } else {

                content.style.maxHeight = '300px';
                colorSelector.classList.add("active")

                // selectcontentor.style.padding = "10px 0";
            }
        })
        let colorOptions = document.querySelectorAll(".ep_colors_selector-option")
        let selectedColor = document.querySelector(".ep_colors_selector-selected-value")
        colorOptions.forEach(colorOption => {
            colorOption.addEventListener("click", ()=>{
                selectedColor.innerHTML = colorOption.innerHTML
                let content = colorSelector.nextElementSibling
                content.style.maxHeight = "0px";
                colorSelector.classList.remove("active")

            })
        })
    }

document.addEventListener('submit', function(event) {
  const form = event.target;
  if (form.matches('form[action="/cart/add"]')) {
    event.preventDefault(); // Stop native submission
    event.stopPropagation(); // Stop theme’s JS

    const addLetterCheckbox = document.getElementById('extra_product');
    const mainProductVariantId = form.querySelector('input[name="id"]')?.value; // Selected variant ID
    const mainProductTitle = addLetterCheckbox?.dataset.mainProductTitle;
    const extraProductVariantId = addLetterCheckbox?.dataset.productId;
    const submitButton = form.querySelector('button[name="add"]');
    const addLetter = addLetterCheckbox?.checked;
    const letterText = document.querySelector('.gift_wrapper-form-wishes')?.value || '';
    const colorSelected = document.querySelector('.ep_colors_selector-selected-value')?.innerText.trim() || '';
    const mainQuantity = parseInt(form.querySelector('input[name="quantity"]')?.value) || 1;

    // Debug logs
    console.log('Selected Variant ID:', mainProductVariantId);
    console.log('Extra Product Variant ID:', extraProductVariantId);
    console.log('Add Letter:', addLetter, 'Quantity:', mainQuantity);

    if (!mainProductVariantId) {
      console.error('No selected variant ID found in form');
      return;
    }

    const items = [
      {
        id: mainProductVariantId,
        quantity: mainQuantity,
        properties: {
          'אות להוספה': addLetter ? letterText : '',
          'צבע נבחר': addLetter ? colorSelected : '',
          'מזהה מוצר אותיות': addLetter ? extraProductVariantId : ''
        }
      }
    ];

    if (addLetter && extraProductVariantId) {
      items.push({
        id: extraProductVariantId,
        quantity: mainQuantity,
        properties: {
          'אות להוספה': letterText,
          'צבע נבחר': colorSelected,
          'מזהה מוצר להוספה': mainProductVariantId,
          'שם מוצר להוספה': mainProductTitle
        }
      });
    }
    submitButton.setAttribute("disabled","");
    submitButton.setAttribute("aria-busy", "");
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(response => response.ok ? response.json() : response.json().then(errorData => Promise.reject(errorData)))
    .then(addedItems => {
      console.log('Items added:', addedItems);
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      const cartDrawer = document.querySelector('.cart-drawer'); // Adjust selector
      if (cartDrawer) {
        cartDrawer.removeAttribute('inert');
        cartDrawer.removeAttribute('hidden');
        cartDrawer.setAttribute('open',""); // Sleek might use this
        cartDrawer.setAttribute('active', "");
        submitButton.removeAttribute("disabled");
        submitButton.removeAttribute("aria-busy");
      } else {
        console.error('Cart drawer not found');
      }
    })
    .catch(error => console.error('Error adding items:', error.description || error));
  }
}, { capture: true });

})
